import { useState } from "react";
import { Table } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { useGetFilterPresets } from "api/queries/user/useGetFilterPresets";
import { FilterPreset } from "types/Common";
import ExpandableSearch from "components/atoms/ExpandableSearch/ExpandableSearch";
import EditFilterPresetDialog from "./EditFilterPresetDialog";
import "./PresetsAndTemplates.scss";

const PresetsTable = function () {
  const [selectedPreset, setSelectedPreset] = useState<FilterPreset>();
  const [showEditFilterPresetDialog, setShowEditFilterPresetDialog] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { data: filterPresetsData, isLoading } = useGetFilterPresets({
    refetchOnMount: false,
  });

  const handleClickRow = (preset: FilterPreset) => () => {
    setSelectedPreset(preset);
    setShowEditFilterPresetDialog(true);
  };

  const filteredData: FilterPreset[] =
    filterPresetsData && Array.isArray(filterPresetsData) // Sometimes API returns {}
      ? searchValue
        ? filterPresetsData.filter((preset) => preset.label.toLowerCase().includes(searchValue.toLowerCase()))
        : filterPresetsData
      : [];

  return (
    <>
      <EditFilterPresetDialog
        isOpen={showEditFilterPresetDialog}
        close={() => setShowEditFilterPresetDialog(false)}
        selectedPreset={selectedPreset}
      />
      <div className="data-table" style={{ maxHeight: "500px", overflow: "auto" }}>
        <div className="d-flex align-items-center mt-4 mb-4">
          <div className="font-weight-bold" style={{ fontSize: "24px" }}>
            <FormattedMessage id="settings.presets" defaultMessage="Presets" />
          </div>
          <div className="ml-3" style={{ width: "fit-content" }}>
            <ExpandableSearch
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
            />
          </div>
        </div>

        <Table bordered size="sm">
          <thead>
            <tr>
              <th>
                <FormattedMessage id="settings.presets.presetName" defaultMessage="Preset Name" />
              </th>
              <th>
                <FormattedMessage id="settings.presets.type" defaultMessage="Type" />
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                {filteredData.length === 0 ? (
                  <tr>
                    <td>
                      <FormattedMessage id="settings.presets.noPresetsFound" defaultMessage="No presets found" />
                    </td>
                  </tr>
                ) : (
                  filteredData.map((filterPreset) => (
                    <tr className="filter-row" key={filterPreset.label} onClick={handleClickRow(filterPreset)}>
                      <td>{filterPreset.label}</td>
                      <td className="text-capitalize">{filterPreset.type.replace("-", " ")}</td>
                    </tr>
                  ))
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

function Loader() {
  return (
    <>
      <tr>
        <td>
          <div className="skeleton" />
        </td>
        <td>
          <div className="skeleton" />
        </td>
      </tr>
      <tr>
        <td>
          <div className="skeleton" />
        </td>
        <td>
          <div className="skeleton" />
        </td>
      </tr>
      <tr>
        <td>
          <div className="skeleton" />
        </td>
        <td>
          <div className="skeleton" />
        </td>
      </tr>
    </>
  );
}

export default PresetsTable;
